// Power Dad Live Orders Popup JavaScript
(function() {
  // Array of sample orders
  const orders = [
    { name: "Rodney", location: "MD", product: "Power Dad Stack", time: "25 minutes ago" },
    { name: "Thomas", location: "PA", product: "Power Dad Stack", time: "50 minutes ago" },
    { name: "Anthony", location: "FL", product: "Power Dad Stack", time: "1 hour 18 minutes ago" },
    { name: "Laura", location: "NM", product: "Power Dad Stack", time: "1 hour 47 minutes ago" },
    { name: "Anthony", location: "NY", product: "Power Dad Stack", time: "2 hours 17 minutes ago" },
    { name: "Johnny", location: "LA", product: "Power Dad Stack", time: "2 hours 48 minutes ago" },
    { name: "Brandon", location: "OH", product: "Power Dad Stack", time: "3 hours 20 minutes ago" },
    { name: "Shaun", location: "CA", product: "Power Dad Stack", time: "3 hours 53 minutes ago" },
    { name: "Joey", location: "GA", product: "Power Dad Stack", time: "4 hours 27 minutes ago" },
    { name: "Nathaniel", location: "TX", product: "Power Dad Stack", time: "5 hours 2 minutes ago" },
    { name: "Johnny", location: "PA", product: "Power Dad Stack", time: "5 hours 38 minutes ago" },
    { name: "Peter", location: "WA", product: "Power Dad Stack", time: "6 hours 15 minutes ago" },
    { name: "Lalonie", location: "CT", product: "Power Dad Stack", time: "6 hours 53 minutes ago" },
    { name: "Matthew", location: "NY", product: "Power Dad Stack", time: "7 hours 32 minutes ago" },
    { name: "Seth", location: "CO", product: "Power Dad Stack", time: "8 hours 12 minutes ago" },
    { name: "Nick", location: "VA", product: "Power Dad Stack", time: "1 hour ago" },
    { name: "Murray", location: "WA", product: "Power Dad Stack", time: "1 hour 15 minutes ago" },
    { name: "Marlon", location: "CA", product: "Power Dad Stack", time: "1 hour 30 minutes ago" },
    { name: "Bryan", location: "MA", product: "Power Dad Stack", time: "1 hour 45 minutes ago" },
    { name: "Nicholas", location: "NJ", product: "Power Dad Stack", time: "2 hours ago" },
    { name: "Kort", location: "CA", product: "Power Dad Stack", time: "2 hours 20 minutes ago" },
    { name: "Alex", location: "FL", product: "Power Dad Stack", time: "2 hours 40 minutes ago" },
    { name: "Mike", location: "ON", product: "Power Dad Stack", time: "3 hours ago" },
    { name: "Ryan", location: "SC", product: "Power Dad Stack", time: "3 hours 20 minutes ago" },
    { name: "Peter", location: "CA", product: "Power Dad Stack", time: "3 hours 40 minutes ago" },
    { name: "Saroop", location: "BC", product: "Power Dad Stack", time: "1 hour 5 minutes ago" },
    { name: "Michael", location: "TX", product: "Power Dad Stack", time: "1 hour 25 minutes ago" },
    { name: "Adan", location: "NC", product: "Power Dad Stack", time: "1 hour 45 minutes ago" },
    { name: "James", location: "MI", product: "Power Dad Stack", time: "2 hours 5 minutes ago" },
    { name: "Thomas", location: "FL", product: "Power Dad Stack", time: "2 hours 25 minutes ago" }
  ];

  // Display popup function
  function showLiveOrder() {
    const randomOrder = orders[Math.floor(Math.random() * orders.length)];
    const popup = document.getElementById('live-orders-popup');
    popup.innerHTML = `
      <div class="popup-content">
        <div class="popup-image">
          <img style="border-radius: 5px;" src="https://cdn.shopify.com/s/files/1/2443/2395/files/Power_Dad_Stack_2_Zoom.png?v=1733357721" alt="Product Image">
          <span class="glow-dot"></span>
        </div>
        <div class="popup-text">
          <div class="popup-line">
            <div class="name-location"><strong>${randomOrder.name} from ${randomOrder.location}</strong></div>
          </div>
          <div class="popup-line product-name"><span class="ordered-text">ordered</span> <strong><span class="product-text">${randomOrder.product}</span></strong></div>
          <div class="popup-line order-time">${randomOrder.time}</div>
          <div class="verified-buyer-badge">Verified Buyer</div>
        </div>
      </div>
    `;
    popup.style.display = 'block';

    setTimeout(() => {
      popup.classList.add('popup-hide');
    }, 6000); // Show for 5 seconds

    setTimeout(() => {
      popup.style.display = 'none';
      popup.classList.remove('popup-hide');
      setTimeout(showLiveOrder, getRandomTimeInterval());
    }, 6500);
  }

  // Random time intervals between popups
  function getRandomTimeInterval() {
    const intervals = [20000, 20000, 20000]; // 20s, 20s, 20s
    return intervals[Math.floor(Math.random() * intervals.length)];
  }

  // Start the popup display
  document.addEventListener('DOMContentLoaded', () => {
    setTimeout(showLiveOrder, getRandomTimeInterval());
  });
})();
